// Imports
import { useStateValue } from '../../_global/jsx/store';
import { ReactProgress } from '../../ReactProgress/jsx/component.jsx';
import { ReactPage } from '../../ReactPage/jsx/component.jsx';
import { ReactLoader } from 'src/modules/ReactLoader/jsx/component.jsx';
import { Modal } from 'src/modules/ReactModal/jsx/Modal.jsx';
import { isDevelopment, sendXHR, failedRequest } from 'src/lib/utils.js';

// Stateful components

export const ReactWrapper = (props) => {

    // Hooks
    const [{ globalText, controlData, modalData }, dispatch] = useStateValue();
    const [appReady, setReady] = React.useState('no');


    //
    // Functions
    //

    // Fetch content from Matrix
    const getAppData = () => {
        let endpoints_container = document.querySelector('#react__app-endpoints');
        let app_data = endpoints_container.getAttribute('data-app-data');

        let xhr_parameters = {
            'request_url': app_data,
            'request_success': processAppData,
            'request_failure': failedRequest,
            'request_extras': ""
        };

        sendXHR(xhr_parameters, 'GET'); 
    };

    // Process app data from Matrix
    const processAppData = (json_response) => {
        let app_data = JSON.parse(json_response);
        
        dispatch({
            'type': 'dataLoaded',
            'value': app_data
        });
    };

    // Render app
    const renderApp = () => {
        let is_loading = controlData['isLoading'];
        let app_loaded = controlData['appLoaded'];

        // Get app data on initial load
        if(!app_loaded) {
            getAppData();
        }

        // Show a loader if waiting for an event
        if(is_loading) {
            return (
                <ReactLoader />
            );
        }

        if(controlData['currentItem']) {
            return (
                <>
                    <Modal />
                    <ReactProgress />
                    <ReactPage />
                </>
            );
        }

        return null;
    }; 
    
    // Listens for when global json is loaded 
    React.useEffect(() =>{
        if(globalText && appReady === 'no') {
            // Update app state
            setReady('yes');

            // Init application
            let action = {
                'type': 'appInit',
                'value': ''
            };

            dispatch(action);
        }
    });

    return renderApp();
};
